import { useState } from "react";
import { useSend2FaOtpMutation } from "../../../../../api/mutations/useSend2FaOtpMutation";
import { extractApiError } from "../../../../../utilities/api";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { authService } from "../../../../../services/AuthService";

export function useSend() {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  const [isRetry, setIsRetry] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [sentTo, setSentTo] = useState(null);

  const { mutateAsync, isLoading } = useSend2FaOtpMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(t([`error.${message}`, "error.sendOtp"]));
    },
    onSuccess: (res) => {
      setIsSuccess(true);
      setSentTo(res?.data?.data?.otp_sent_to || null);
    },
  });

  const initiate = async ({ altType, answer, passcode }) => {
    return mutateAsync({
      method: altType,
      answer: answer || null,
      passcode: passcode || null,
      wpuId: authService.getPreLoginData().wpuId,
    });
  };

  return {
    initiate: async ({ altType, answer, passcode }) => {
      setIsRetry(false);
      return initiate({ altType, answer, passcode });
    },
    retry: async ({ altType, answer, passcode }) => {
      setIsRetry(true);
      return initiate({ altType, answer, passcode })
        .then(() => {
          uiNotification.success(t("success.otpResent"));
        })
        .finally(() => {
          setIsRetry(false);
        });
    },
    isLoading,
    isRetrying: isRetry,
    isSuccess,
    sentTo,
  };
}
